import React from 'react'

const first24Vietnam = {
    id: 'first-24-hours-vietnam',
    type: 'post',
    countryId: 'seAsia',
    title: 'Our First 24 Hours in Vietnam',
    longDate: 'October 6, 2018',
    month: 'Oct',
    date: '6',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/Vietnam.jpg',
    content: [
        {
            text: (
                <div>I'm starting to feel we were maybe a bit crazy to commit to living somewhere for 6 months having never visited it, but 24 hours in, we really like Vietnam.</div>
            )
        },
        {
            text: (
                <div>I'd heard that Hanoi can feel a bit heavy and communist, but personally – as a Russian history major – I find it interesting and intriguing. It seems at least some Vietnamese are light-hearted about it; there's a chain of "<a href="https://wander-lush.org/best-cafes-in-hanoi-vietnam-cong/">communist chic</a>" cafes called Cong Ca Phe where the servers wear ironic party outfits (that's Communist party, not rage rage party) and decorate with old photos and army green.</div>
            )
        },
        {
            text: (
                <div>It is definitely hectic, and crossing the street is a skill you need to learn quickly. Peter says that's been the most surprising thing for him; India and Peru were the most comparable places we've visited, but Peru had far less traffic plus stoplights and pedestrian right-of-way, while India didn't have this crazy amount of motorbikes. It's pretty easy to pick up, though: walk slowly and steadily, staring down the motorbike drivers as you walk into their path (kidding… kind of.)</div>
            )
        },
        {
            text: (
                <div>So far we've eaten pho twice and noodles for the other two meals, so the street food exploration is going well. As I write this we're headed to a cooking class and a biking/street food tour in the next couple of days, and can't wait to get to know Vietnamese cuisine.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/PeterHanoi.jpg',
            detailText: 'Fried rice (cơm chiên) in our alley.'
        },
        {
            text: (
                <div>When we flew in, we landed late at night and went straight to sleep, staying in bed until almost 1 the next day. So I'm counting our first 24 hours from then on!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/Garden.jpg',
            detailText: 'Hanoi has tons of greenery, including the garden outside our apartment.'
        },
        {
            text: (
                <div>First up: revive from zombie status by finding coffee. We were pretty hungry and didn't have much energy to search for a great spot, so just headed for the first place Peter found on Google Maps. It was named 'No 1. Coffee' (in English) so you can guess that it was a little pricey, but the traditional Vietnamese-style coffee was actually really tasty. I stared into space for 20 minutes while it slowly dripped into the saucer, and didn't feel truly awake until halfway through lunch.</div>
            )
        },
        {
            text: (
                <div>Luckily, we didn't have to go far to find street food. We rented an Airbnb in the Ba Dinh district, which is bustling with vendors. One thing that did surprise both of us is that street food is served seated, on tiny plastic chairs. I had pictured those food markets that Anthony Bourdain was always in, walking while eating a skewer. We'd heard that Vietnamese people take their food very seriously, and that if you ever see an empty food spot it's empty for a reason. For our first meal, we walked into the nearest spot with the word 'Pho' on a board that had people in it at 2 p.m. Can't go wrong with pho: this was delicious, and only $3.50 for two bowls with beef and two bottled waters.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/FirstPho.jpg',
            detailText: 'Our first bowls of pho, of many to come.'
        },
        {
            text: (
                <div>Next up were some admin items: find the nearest grocery store so we could eventually cook in our place, find the SIM card store, and find a massive amount of bottled water to hoard. We only succeeded in the last one. No clue if the grocery store and SIM card place actually exist somewhere in the vicinity of where Google Maps showed them, but we were unable to locate them and didn't see any grocery stores the whole day. (Update post-cooking class: Vietnamese people do most of their shopping at the markets, but go to supermarkets to stock up on essentials; they're usually located inside shopping centers, so you wouldn't see them from the street.)</div>
            )
        },
        {
            text: (
                <div>After a couple of hours walking around fruitlessly, we slumped back to our A.C. and did some Googling. Apparently there are tons of storefronts selling <a href="https://www.contentedtraveller.com/getting-best-sim-card-vietnam/">SIM cards in Vietnam</a> but only one government-sponsored company, Viettel. The government recently shut down a ton of the less-legal vendors, turning off cell and data for anyone who'd bought one from them.</div>
            )
        },
        {
            text: (
                <div>We'd also read that you can identify the real Viettel stores by the loud music pumping through the open door and uniformed employees – confirmed, when we found the Viettel in the Old Quarter blasting pop. It only costs 600,000 VND (~$26) for a YEAR of 4GB/month data. In San Francisco, Peter and I shared 4GB and paid about $90/month on a family plan that included call and text. We don't have call or text on the Vietnamese plan but ignoring that fact, it's literally one fortieth of the price in America. Verizon, please explain yourself.</div>
            )
        },
        {
            text: (
                <div>Since we were already out in the Old Quarter, we stayed the evening. Peter had looked up places to watch the upcoming Liverpool game, so we scoped out <a href="https://www.tripadvisor.com/Restaurant_Review-g293924-d1236678-Reviews-Puku_Cafe_and_Sports_Bar-Hanoi.html">Puku</a> to make sure they'd have the game on and stuck around for a few drinks, chatting with a table of Australians (who else?)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/Night.jpg'
        },
        {
            text: (
                <div>Dinner was a bit disappointing, but that's totally on us for going to a dim sum place for anything other than breakfast. Still good, just not great.</div>
            )
        },
        {
            text: (
                <div>We used the Southeast Asian Uber, <a href="https://www.grab.com/vn/en/about/">Grab</a>, to get home, and passed out early. The next morning when I woke up at 3:30 and couldn't get back to sleep, I regretted sleeping so much the day before. Peter stayed asleep while I read for three hours, then continued to stay asleep while I went on a hunt for food and found breakfast pho.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/SecondPho.jpg',
            detailText: 'The second pho bowl of many to come.'
        },
        {
            text: (
                <div>The light was gorgeous early in the morning and I'd brought my camera, so I wandered around Ba Dinh and tested out some photos. I had seen 'Fishing Pond' on the map and made my way there, but instead discovered the <a href="https://www.tripadvisor.com/Attraction_Review-g293924-d455010-Reviews-Huu_Tiep_Lake_and_the_Downed_B_52-Hanoi.html">wreckage of a B-52 bomber</a> in the middle of the pond with a memorial plaque. A bit surreal for 7 a.m.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/BomberLake.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/meatstand.jpg',
            detailText: 'Most food items can be purchased out of street stalls, like this one in the alleys behind our apartment.'
        },
        {
            text: (
                <div>At the time of writing we were close to finishing everything needed to get this blog live, and decided to get some work done with the rest of our morning then try to nap after lunch. There was a Cong Ca Phe location near us, so I got the famous coconut coffee in both hot and cold versions (cold wins, and Vietnamese coffee is <i>so good</i>.)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/CongCaphe.jpg',
            detailText: "I recently heard Cong Caphe described as the Starbucks of Hanoi, but it's way cooler."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/first24hours/CoconutCoffee.jpg',
            detailText: 'Coconut coffee, the hot version.'
        },
        {
            text: (
                <div>For lunch we decided to try the street food in our alley, and sat down having no idea what they served. The woman running it spoke a little English and said it was either fried noodles or fried rice, so we tried one of each. The fried rice tasted surprisingly similar to what we'd had at home, neon red sour pork and all.</div>
            )
        },
        {
            text: (
                <div>It's been really nice landing in Vietnam with zero plans. As we meet people and do online research, we're planning what to do with our time in the north before traveling down this long skinny country to Ho Chi Minh. Onward to the rest of our time in Hanoi!</div>
            )
        }
    ]
}


export default first24Vietnam


// WEBPACK FOOTER //
// ./src/Posts/Content/First24Vietnam.js